import _ from 'underscore'
import React from 'react'
import { Button, Icon } from 'semantic-ui-react'

import AppConstants from './AppConstants'
import AppUtils from './AppUtils'
import Details from '../components/elements/Details'
import LocationStickers from '../components/elements/LocationStickers'
import Table from '../components/elements/Table'
import Sticker from '../components/elements/Sticker'
import ColorPicker from '../components/elements/ColorPicker'
import TextInput from '../components/elements/forms/TextInput'
import IntegerInput from '../components/elements/forms/IntegerInput'
import Grant from '../containers/elements/Grant'

const ColumnsProvider = {
  actionGoTo: (callback, accessor='id') => ({
    id: 'action',
    title: '',
    render: (row) => {
      const computedAccessor = _.isFunction(accessor)
        ? accessor(row)
        : accessor
      return (
        <Button
          compact={true}
          icon='arrow right'
          color='blue'
          onClick={callback(AppUtils.accessByString(row, computedAccessor), row)}
        />
      )
    },
    width: '40px',
    align: 'right'
  }),
  actionsUpdateDelete: (updateCallback, deleteCallback, updateRole=Grant.ROLE.MANAGE, deleteRole=Grant.ROLE.ADMIN) => ({
    id: 'actions',
    title: '',
    render: (row) => (
      <React.Fragment>
        <Grant role={updateRole}>
          <Button
            compact={true}
            icon='pencil'
            color='orange'
            onClick={updateCallback(row.id)}
          />
        </Grant>
        <Grant role={deleteRole}>
          <Button
            compact={true}
            icon='trash'
            color='red'
            onClick={deleteCallback(row.id)}
          />
        </Grant>
      </React.Fragment>
    ),
    width: '80px',
    align: 'right'
  }),
  actionsPrintUpdateDelete: (printCallback, updateCallback, deleteCallback, updateRole=Grant.ROLE.MANAGE, deleteRole=Grant.ROLE.ADMIN) => ({
    id: 'actions',
    title: '',
    render: (row) => (
      <React.Fragment>
        <Button
          compact={true}
          icon='print'
          color='blue'
          onClick={printCallback(row.id)}
        />
        <Grant role={updateRole}>
          <Button
            compact={true}
            icon='pencil'
            color='orange'
            onClick={updateCallback(row.id)}
          />
        </Grant>
        <Grant role={deleteRole}>
          <Button
            compact={true}
            icon='trash'
            color='red'
            onClick={deleteCallback(row.id)}
          />
        </Grant>
      </React.Fragment>
    ),
    width: '120px',
    align: 'right'
  }),
  categoryActions: (context) => ({
    id: 'actions',
    title: '',
    render: (row) => (
      <React.Fragment>
        <Grant role={Grant.ROLE.MANAGE}>
          <Button
            compact={true}
            icon='caret up'
            className='not-for-first'
            loading={
              context.props.categoryReorderIsFetching
              &&
              context.props.categoryReorderId === row.id
              &&
              context.props.categoryReorderData
              &&
              context.props.categoryReorderData.direction === AppConstants.REORDER.UP
            }
            onClick={context.onClickReorderCategory(row.id, AppConstants.REORDER.UP)}
          />
        </Grant>
        <Grant role={Grant.ROLE.MANAGE}>
          <Button
            compact={true}
            icon='caret down'
            className='not-for-last'
            loading={
              context.props.categoryReorderIsFetching
              &&
              context.props.categoryReorderId === row.id
              &&
              context.props.categoryReorderData
              &&
              context.props.categoryReorderData.direction === AppConstants.REORDER.DOWN
            }
            onClick={context.onClickReorderCategory(row.id, AppConstants.REORDER.DOWN)}
          />
        </Grant>
        <Grant role={Grant.ROLE.MANAGE}>
          <Button
            compact={true}
            icon='pencil'
            color='orange'
            onClick={context.onClickUpdateCategory(row.id)}
          />
        </Grant>
        <Grant role={Grant.ROLE.ADMIN}>
          <Button
            compact={true}
            icon='trash'
            color='red'
            onClick={context.onClickDeleteCategory(row.id)}
          />
        </Grant>
        <Button
          compact={true}
          icon='arrow right'
          color='yellow'
          onClick={context.onSelectCategory(row.id)}
        />
      </React.Fragment>
    ),
    width: '160px',
    align: 'right'
  }),
  colorActions: (context) => ({
    id: 'actions',
    title: '',
    render: (row) => (
      (
        context.state.create
        &&
        row.id === 'new'
      )
      ||
      (
        context.state.edit
        &&
        context.state.edit.id === row.id
      )
        ? <React.Fragment>
            <Button
              compact={true}
              icon='checkmark'
              color='green'
              className='always'
              loading={
                (
                  context.state.create
                  &&
                  context.props.postIsFetching
                )
                ||
                (
                  context.state.edit
                  &&
                  context.props.putIsFetching
                )
              }
              onClick={context.onClickValid}
            />
            <Button
              compact={true}
              icon='close'
              color='red'
              className='always'
              disabled={
                (
                  context.state.create
                  &&
                  context.props.postIsFetching
                )
                ||
                (
                  context.state.edit
                  &&
                  context.props.putIsFetching
                )
              }
              onClick={context.onClickCancel}
            />
          </React.Fragment>
        : <React.Fragment>
            <Grant role={Grant.ROLE.MANAGE}>
              <Button
                compact={true}
                icon='pencil'
                color='orange'
                disabled={context.state.create || context.state.edit}
                onClick={context.onClickEdit(row.id)}
              />
            </Grant>
            <Grant role={Grant.ROLE.ADMIN}>
              <Button
                compact={true}
                icon='trash'
                color='red'
                disabled={context.state.create || context.state.edit}
                onClick={context.onClickDelete(row.id)}
              />
            </Grant>
          </React.Fragment>
    ),
    width: '75px',
    align: 'right'
  }),
  colorName: (context) => ({
    id: 'name',
    title: 'Nom',
    render: (row) => (
      context.state.edit
      &&
      context.state.edit.id === row.id
        ? <TextInput
            placeholder='Rouge'
            value={context.state.edit.name}
            onChange={context.onChangeEditName}
          />
        : (
            context.state.create
            &&
            row.id === 'new'
              ? <TextInput
                  placeholder='Rouge'
                  value={context.state.create.name}
                  onChange={context.onChangeCreateName}
                />
              : row.name
          )
    )
  }),
  colorShowAndEdit: (context, attribute, title, callbackCreate, callbackEdit) => ({
    id: attribute,
    title,
    render: (row) => (
      context.state.edit
      &&
      context.state.edit.id === row.id
        ? <ColorPicker
            hex={context.state.edit[attribute]}
            onChange={callbackEdit}
          />
        : (
            context.state.create
            &&
            row.id === 'new'
              ? <ColorPicker
                  hex={context.state.create[attribute]}
                  onChange={callbackCreate}
                />
              : <Sticker
                  circular={true}
                  foreground={row[attribute]}
                  background={row[attribute]}
                  text='A'
                />
          )
    ),
    width: '100px',
    align: 'center',
    stickers: true
  }),
  controlActions: (callbackView, callbackDelete) => ({
    id: 'actions',
    title: '',
    render: (row) => (
      <React.Fragment>
        <Grant role={Grant.ROLE.ADMIN}>
          <Button
            compact={true}
            icon='trash'
            color='red'
            onClick={callbackDelete(row.id)}
          />
        </Grant>
        <Button
          compact={true}
          icon='arrow right'
          color='blue'
          onClick={callbackView(row.id)}
        />
      </React.Fragment>
    ),
    width: '100px',
    align: 'right'
  }),
  controlNameWithLink: (callbackSelect) => ({
    id: 'control_name',
    title: 'Contrôle',
    render: (row) => (
      <React.Fragment>
        <span>
          {row.control.name}
        </span>
        <Button
          compact={true}
          icon='arrow right'
          color='blue'
          style={{
            float: 'right'
          }}
          onClick={callbackSelect(row.control.id)}
        />
      </React.Fragment>
    )
  }),
  controlNextWithDetails: {
    id: 'next',
    title: 'Prochain',
    render: (row) => {
      if (!row.recurrence.periodic) {
        return '-'
      }
      if (_.size(row.groups) === 0) {
        return 'Au plus vite'
      }
      const groups = _.map(
        _.sortBy(row.groups, (group) => (
          group.next === 'ASAP' ? '2000-01-01' : group.next
        )),
        (group) => _.extend({}, group, {
          remaining: AppUtils.dateToReminder(
            group.next === 'ASAP' ? null : group.next
          )
        })
      )
      return (
        <React.Fragment>
          {groups[0].remaining.text}
          {' '}
          <Details
            icon={groups[0].remaining.icon || Details.ICON.INFO}
            action={Details.ACTION.CLICK}
            content={
              <div style={{
                width: '300px',
                maxHeight: '250px',
                display: 'flex',
                flexDirection: 'column'
              }}>
                <Table
                  columns={[
                    // Groupe
                    ColumnsProvider.controlGroupName,
                    // Prochain
                    ColumnsProvider.controlGroupNextWithDetails
                  ]}
                  data={groups}
                  error={null}
                  isLoading={false}
                  emptyMessage="Aucun groupe."
                  float={true}
                />
              </div>
            }
          />
        </React.Fragment>
      )
    },
    width: '150px'
  },
  controlRecurrence: {
    id: 'recurrence',
    title: 'Récurrence',
    render: (row) => (
      row.recurrence.periodic
        ? `Tous les ${row.recurrence.value} mois`
        : row.recurrence.value
    ),
    width: '300px'
  },
  controlGroupActions: (printCallback, executeCallback, updateCallback, deleteCallback) => ({
    id: 'actions',
    title: '',
    render: (row) => (
      <React.Fragment>
        <Button
          compact={true}
          icon='print'
          color='blue'
          onClick={printCallback(row.id)}
        />
        <Grant role={Grant.ROLE.MANAGE}>
          <Button
            compact={true}
            icon='checkmark'
            color='green'
            onClick={executeCallback(row.id)}
          />
        </Grant>
        <Grant role={Grant.ROLE.MANAGE}>
          <Button
            compact={true}
            icon='pencil'
            color='orange'
            onClick={updateCallback(row.id)}
          />
        </Grant>
        <Grant role={Grant.ROLE.MANAGE}>
          <Button
            compact={true}
            icon='trash'
            color='red'
            onClick={deleteCallback(row.id)}
          />
        </Grant>
      </React.Fragment>
    ),
    width: '130px',
    align: 'right'
  }),
  controlGroupUserFunction: {
    id: 'function',
    title: 'Fonction',
    render: (row) => (
      row.isManager
        ? 'Responsable'
        : 'Aide'
    ),
    width: '100px'
  },
  controlGroupHelpers: {
    id: 'helpers',
    title: 'Aides',
    render: (row) => (
      <React.Fragment>
        {row.helpers.length}
        {' '}
        <Details
          icon={Details.ICON.INFO}
          action={Details.ACTION.HOVER}
          inverted={true}
          content={
            <div style={{
              width: '200px',
              maxHeight: '200px',
              display: 'flex',
              flexDirection: 'column'
            }}>
              <Table
                columns={[{
                  id: 'helper',
                  title: 'Nom',
                  render: (row) => (row.name)
                }]}
                data={row.helpers}
                error={null}
                isLoading={false}
                emptyMessage="Aucun aide n'est encore assigné à ce groupe de contrôle."
                float={true}
              />
            </div>
          }
        />
      </React.Fragment>
    ),
    width: '60px'
  },
  controlGroupLast: {
    id: 'last',
    title: 'Dernier',
    render: (row) => (
      row.executions && row.executions.length
        ? AppUtils.displayDate(row.executions[0].date)
        : 'Jamais'
    ),
    width: '100px'
  },
  controlGroupLocations: {
    id: 'locations',
    title: 'Emplacements',
    render: (row) => {
      switch (row.locations.length) {
        case 0:
          return '-'
        case 1:
          return (
            <LocationStickers
              stickers={row.locations[0].stickers}
            />
          )
        default:
          return (
            <React.Fragment>
              {row.locations.length}
              {' '}
              <Details
                icon={Details.ICON.INFO}
                action={Details.ACTION.HOVER}
                inverted={true}
                content={
                  <div style={{
                    width: '120px',
                    maxHeight: '200px',
                    display: 'flex',
                    flexDirection: 'column'
                  }}>
                    <Table
                      columns={[{
                        id: 'location',
                        title: 'Emplacement',
                        render: (row) => (
                          <LocationStickers
                            stickers={row.stickers}
                          />
                        )
                      }]}
                      data={row.locations}
                      error={null}
                      isLoading={false}
                      emptyMessage="Aucun emplacement n'est encore assigné à ce groupe de contrôle."
                      float={true}
                    />
                  </div>
                }
              />
            </React.Fragment>
          )
      }
    },
    width: '140px'
  },
  controlGroupManager: {
    id: 'manager',
    title: 'Responsable',
    render: (row) => (row.manager.name)
  },
  controlGroupName: {
    id: 'name',
    title: 'Groupe'
  },
  controlGroupNextWithDetails: {
    id: 'next',
    title: 'Prochain',
    render: (row) => {
      if (!row.next) {
        return (
          <React.Fragment>
            {'- '}
            {
              <Details
                icon={Details.ICON.INFO}
                action={Details.ACTION.HOVER}
                content={'Non périodique'}
              />
            }
          </React.Fragment>
        )
      }
      const remaining = row.remaining
        ? row.remaining
        : AppUtils.dateToReminder(
            row.next === 'ASAP' ? null : row.next
          )
      return (
        <React.Fragment>
          {remaining.text}
          {' '}
          {
            remaining.icon
              ? <Details
                  icon={remaining.icon}
                  action={Details.ACTION.HOVER}
                  content={remaining.details}
                />
              : null
          }
        </React.Fragment>
      )
    },
    width: '120px'
  },
  controlContact: {
    id: 'contact',
    title: 'Contact d\'entretien',
    render: (row) => {
      switch (row.contact.type) {
        case AppConstants.CONTACT.TYPE.SELF:
          return 'Celui qui effectue le contrôle'
        case AppConstants.CONTACT.TYPE.OWNER:
          return 'Responsable du groupe matériel'
        case AppConstants.CONTACT.TYPE.SPECIFIC:
          return row.contact.user.name
        default:
          return '-'
      }
    }
  },
  controlProductName: {
    id: 'product',
    title: 'Matériel',
    render: (row) => (row.product.name)
  },
  controlProductOperation: {
    id: 'operation',
    title: 'Opération'
  },
  controlProductActions: (updateCallback, deleteCallback) => ({
    id: 'actions',
    title: '',
    render: (row) => (
      <React.Fragment>
        <Grant role={Grant.ROLE.MANAGE}>
          <Button
            compact={true}
            icon='pencil'
            color='orange'
            onClick={updateCallback(row.product.id)}
          />
        </Grant>
        <Grant role={Grant.ROLE.MANAGE}>
          <Button
            compact={true}
            icon='trash'
            color='red'
            onClick={deleteCallback(row.product.id)}
          />
        </Grant>
      </React.Fragment>
    ),
    width: '80px',
    align: 'right'
  }),
  controlTaskDescription: {
    id: 'description',
    title: 'Tâche'
  },
  controlProductOrTaskContactDetails: (callbackSelectProduct) => ({
    id: 'product_task',
    title: 'Matériel/Tâche',
    render: (row) => (
      <React.Fragment>
        <span>
          {
            row.product
              ? row.product.name
              : row.task
          }
        </span>
        {
          row.product
            ? <Button
                compact={true}
                icon='arrow right'
                color='blue'
                style={{
                  float: 'right'
                }}
                onClick={callbackSelectProduct(row.product.id)}
              />
            : null
        }
      </React.Fragment>
    )
  }),
  controlOrMaintenanceType: {
    id: 'maintenance_or_control',
    title: 'Type',
    render: (row) => (
      row.maintenance
        ? 'Maintenance'
        : 'Contrôle'
    ),
    width: '101px'
  },
  controlOrMaintenanceDetails: {
    id: 'details',
    title: 'Description',
    render: (row) => (
      row.maintenance
        ? `${row.maintenance.name} (exécuté par ${row.maintenance.outside ? 'externe' : 'SIS'})`
        : `${row.control.control.name} - ${row.control.operation}`
    )
  },
  controlOrMaintenanceRecurrence: {
    id: 'recurrence',
    title: 'Récurrence',
    render: (row) => (
      row.maintenance
        ? AppUtils.displayPeriodicity(row.maintenance.periodicity)
        : (
            row.control.control.recurrence.periodic
              ? `Tous les ${row.control.control.recurrence.value} mois`
              : <React.Fragment>
                  {'Non périodique '}
                  <Details
                    icon={Details.ICON.INFO}
                    action={Details.ACTION.HOVER}
                    content={row.control.control.recurrence.value}
                  />
                </React.Fragment>
          )
    ),
    width: '138px'
  },
  controlOrMaintenanceNext: {
    id: 'next',
    title: 'Prochain(e)',
    render: (row) => {
      if (_.isNull(row.next)) {
        return '-'
      }
      const remaining = AppUtils.dateToReminder(row.next === 'ASAP' ? null : row.next)
      return (
        <React.Fragment>
          {remaining.text}
          {' '}
          {
            remaining.icon
              ? <Details
                  icon={remaining.icon}
                  action={Details.ACTION.HOVER}
                  content={remaining.details}
                />
              : null
          }
        </React.Fragment>
      )
    },
    width: '130px'
  },
  diameterDiameter: {
    id: 'diameter',
    title: 'Diamètre (mm)'
  },
  executionItemInput: (onChange) => ({
    id: 'input',
    title: 'Saisie',
    render: (row) => (
      <React.Fragment>
        <Button.Group
          compact={true}
        >
          <Button
            className='always'
            icon='circle outline'
            color={row.status === AppConstants.PRODUCT.ITEM.MAINTENANCE.STATUS.NONE ? 'orange' : undefined}
            basic={row.status !== AppConstants.PRODUCT.ITEM.MAINTENANCE.STATUS.NONE}
            onClick={() => { onChange(row.location, row.item, 'status')(AppConstants.PRODUCT.ITEM.MAINTENANCE.STATUS.NONE) }}
          />
          <Button
            className='always'
            icon='checkmark'
            color={row.status === AppConstants.PRODUCT.ITEM.MAINTENANCE.STATUS.SUCCESS ? 'green' : undefined}
            basic={row.status !== AppConstants.PRODUCT.ITEM.MAINTENANCE.STATUS.SUCCESS}
            onClick={() => { onChange(row.location, row.item, 'status')(AppConstants.PRODUCT.ITEM.MAINTENANCE.STATUS.SUCCESS) }}
          />
          <Button
            className='always'
            icon='close'
            color={row.status === AppConstants.PRODUCT.ITEM.MAINTENANCE.STATUS.FAILURE ? 'red' : undefined}
            basic={row.status !== AppConstants.PRODUCT.ITEM.MAINTENANCE.STATUS.FAILURE}
            onClick={() => { onChange(row.location, row.item, 'status')(AppConstants.PRODUCT.ITEM.MAINTENANCE.STATUS.FAILURE) }}
          />
        </Button.Group>
        {
          !_.isUndefined(row.remark)
            ? <TextInput
                style={{
                  marginLeft: '4px',
                  width: '150px'
                }}
                placeholder='Remarque'
                value={row.remark}
                onChange={onChange(row.location, row.item, 'remark')}
              />
            : null
        }
      </React.Fragment>
    ),
    width: '250px'
  }),
  executionItemStatus: {
    id: 'status',
    title: 'Status',
    render: (row) => {
      let icon, content
      switch (row.status) {
        case AppConstants.PRODUCT.ITEM.MAINTENANCE.STATUS.NONE:
          icon = Details.ICON.WARNING
          content = 'Pas exécutée'
          break
        case AppConstants.PRODUCT.ITEM.MAINTENANCE.STATUS.SUCCESS:
          icon = Details.ICON.SUCCESS
          content = 'Succès'
          break
        case AppConstants.PRODUCT.ITEM.MAINTENANCE.STATUS.FAILURE:
          icon = Details.ICON.FAILURE
          content = `Echec: ${row.remark}`
          break
        default:
          icon = Details.ICON.INFO
          content = 'Status inconnu'
          break
      }
      return (
        <Details
          icon={icon}
          action={Details.ACTION.HOVER}
          content={content}
        />
      )
    },
    width: '80px',
    align: 'center'
  },
  genericName: {
    id: 'name',
    title: 'Nom'
  },
  genericColor: {
    id: 'color',
    title: 'Couleur',
    render: (row) => (
      <React.Fragment>
        <Sticker
          circular={true}
          foreground={row.color.foreground}
          background={row.color.background}
          text='A'
        />
        {' '}
        {row.color.name}
      </React.Fragment>
    ),
    stickers: true,
    width: '200px'
  },
  genericDate: {
    id: 'date',
    title: 'Date',
    render: (row) => (AppUtils.displayDate(row.date)),
    width: '100px'
  },
  inventoryItemFillExpected: {
    id: 'expected',
    title: 'Supposé',
    width: '100px',
    align: 'center'
  },
  inventoryItemFillFound: (onChange) => ({
    id: 'found',
    title: 'Trouvé',
    render: (row) => (
      <IntegerInput
        style={{
          maxWidth: '80px'
        }}
        value={row.found}
        onChange={onChange(row.location, row.compartment, row.category, row.index)}
        max={row.expected}
      />
    ),
    width: '100px'
  }),
  inventoryItemFillStatus: {
    id: 'status',
    title: 'Status',
    render: (row) => {
      let icon, content
      if (!_.isString(row.found)) {
        if (row.found >= row.expected) {
          icon = Details.ICON.SUCCESS
          content = 'Toutes les pièces trouvées'
        }
        else {
          icon = Details.ICON.FAILURE
          content = `${row.expected - row.found} pièce${row.expected - row.found > 1 ? 's' : ''} manquante${row.expected - row.found > 1 ? 's' : ''}`
        }
      }
      else {
        icon = Details.ICON.WARNING
        content = 'Saisie non terminée'
      }
      return (
        <Details
          icon={icon}
          action={Details.ACTION.HOVER}
          content={content}
        />
      )
    },
    width: '80px',
    align: 'center'
  },
  inventoryItemStatus: {
    id: 'found',
    title: 'Status',
    render: (row) => (
      <Details
        icon={
          row.found
            ? Details.ICON.SUCCESS
            : Details.ICON.FAILURE
        }
        action={Details.ACTION.HOVER}
        content={
          row.found
            ? 'Présent'
            : 'Absent'
        }
      />
    ),
    width: '80px',
    align: 'center'
  },
  inventoryProductExpected: {
    id: 'expected',
    title: 'Supposé',
    render: (row) => (_.size(row.items)),
    width: '140px',
    align: 'center'
  },
  inventoryProductFound: {
    id: 'found',
    title: 'Trouvé',
    render: (row) => (_.size(_.filter(row.items, (item) => (item.found)))),
    width: '140px',
    align: 'center'
  },
  inventoryProductStatus: (historyCallback) => ({
    id: 'status',
    title: 'Status',
    render: (row) => (
      <Details
        icon={
          _.size(_.filter(row.items, (item) => (!item.found))) > 0
            ? Details.ICON.FAILURE
            : Details.ICON.SUCCESS
        }
        action={Details.ACTION.CLICK}
        content={
          <div style={{
            width: `${500 + (_.isNull(row.product.prefix) ? 0 : 90)}px`,
            maxHeight: '320px',
            display: 'flex',
            flexDirection: 'column'
          }}>
            <Table
              columns={_.union(
                // N°
                !_.isNull(row.product.prefix)
                  ? [ ColumnsProvider.itemNumberFull ]
                  : [],
                [
                  // Emplacement
                  ColumnsProvider.locationStickers,
                  // Compartiment
                  ColumnsProvider.itemCompartmentBasic,
                  // Status
                  ColumnsProvider.inventoryItemStatus,
                  // Action
                  ColumnsProvider.itemActions(false, historyCallback)
                ]
              )}
              data={row.items}
              error={null}
              isLoading={false}
              emptyMessage="Aucune pièce n'a été inventoriée pour ce matériel."
              float={true}
            />
          </div>
        }
      />
    ),
    width: '100px',
    align: 'center'
  }),
  inventoryRemark: {
    id: 'remark',
    title: 'Remarque'
  },
  inventoryResult: {
    id: 'result',
    title: 'Résultat',
    render: (row) => (
      <Details
        icon={
          row.missing === 0
            ? Details.ICON.SUCCESS
            : Details.ICON.FAILURE
        }
        action={Details.ACTION.HOVER}
        content={
          row.missing === 0
            ? 'Toutes les pièces trouvées'
            : `${row.missing} pièce${row.missing > 1 ? 's' : ''} manquante${row.missing > 1 ? 's' : ''}`
        }
      />
    ),
    width: '80px',
    align: 'center'
  },
  inventoryUserAndPeople: {
    id: 'people',
    title: 'Fait par',
    render: (row) => (
      <React.Fragment>
        {row.user.name}
        {' '}
        <Details
          icon={Details.ICON.INFO}
          action={Details.ACTION.HOVER}
          content={`Avec ${row.people}`}
        />
      </React.Fragment>
    ),
    width: '180px'
  },
  inventoryTitle: {
    id: 'title',
    title: 'Titre'
  },
  itemActions: (canEdit, callbackHistory, callbackUpdatem=null, callbackDelete=null) => ({
    id: 'actions',
    title: '',
    render: (row) => (
      <React.Fragment>
        <Button
          compact={true}
          icon='clock'
          onClick={callbackHistory(row.id)}
        />
        {
          _.isNull(row.deleted) && canEdit
            ? <React.Fragment>
                <Grant role={Grant.ROLE.MANAGE}>
                  <Button
                    compact={true}
                    icon='pencil'
                    color='orange'
                    onClick={callbackUpdatem(row.id)}
                  />
                </Grant>
                <Grant role={Grant.ROLE.MANAGE}>
                  <Button
                    compact={true}
                    icon='trash'
                    color='red'
                    onClick={callbackDelete(row.id)}
                  />
                </Grant>
              </React.Fragment>
            : null
        }
      </React.Fragment>
    ),
    width: canEdit
      ? '100px'
      : '40px',
    align: 'right'
  }),
  itemCompartmentBasic: {
    id: 'compartment',
    title: 'Compartiment',
    render: (row) => (
      <span style={ row.deleted ? { color: 'red'} : {} }>
        {row.compartment}
      </span>
    )
  },
  itemCompartmentMultiple: (context) => ({
    id: 'compartment',
    title: 'Compartiment',
    render: (row) => {
      let compartments = context
        ? ( _.isString(row.compartment)
              ? row.compartment
              : _.filter(
                  row.compartment,
                  (compartment) => (
                    compartment.quantity_active > 0
                    ||
                    context.state.itemsShowDeleted
                  )
                )
          )
        : row.compartments
      if (_.isArray(compartments) && _.size(compartments) === 1) {
        compartments = compartments[0].compartment
      }
      return (
        _.isString(compartments)
          ? compartments
          : <React.Fragment>
              {`(${_.size(compartments)}) `}
              <Details
                icon={Details.ICON.INFO}
                action={Details.ACTION.CLICK}
                content={
                  <div style={{
                    width: '240px',
                    maxHeight: '160px',
                    display: 'flex',
                    flexDirection: 'column'
                  }}>
                    <Table
                      columns={[
                        ColumnsProvider.itemCompartmentBasic,
                        context
                          ? ColumnsProvider.itemQuantityWithDeleted(context)
                          : ColumnsProvider.itemQuantity
                      ]}
                      data={compartments}
                      error={null}
                      isLoading={false}
                      emptyMessage="Aucun compartiment à afficher."
                      float={true}
                    />
                  </div>
                }
              />
            </React.Fragment>
      )
    }
  }),
  itemCreated: {
    id: 'created',
    title: 'Ajouté',
    render: (row) => (
      <React.Fragment>
        <span style={ row.deleted ? { color: 'red'} : {} }>
          {AppUtils.displayDate(row.created.date)}
        </span>
        <Details
          icon={Details.ICON.INFO}
          action={Details.ACTION.HOVER}
          content={`Par ${row.created.user.name}`}
        />
      </React.Fragment>
    ),
    width: '120px'
  },
  itemDeleted: {
    id: 'deleted',
    title: 'Supprimé',
    render: (row) => (
      row.deleted
        ? <React.Fragment>
            <span style={ row.deleted ? { color: 'red'} : {} }>
              {AppUtils.displayDate(row.deleted.date)}
            </span>
            <Details
              icon={Details.ICON.INFO}
              action={Details.ACTION.HOVER}
              content={`Par ${row.deleted.user.name}`}
            />
          </React.Fragment>
        : null
    ),
    width: '120px'
  },
  itemHistoryAction: (context) => ({
    id: 'action',
    title: '',
    render: (row) => {
      let callback
      switch (row.type) {
        case AppConstants.PRODUCT.ITEM.EVENT.TYPE.INVENTORY:
          callback = context.onClickGoToInventory
          break
        case AppConstants.PRODUCT.ITEM.EVENT.TYPE.MAINTENANCE:
          callback = context.onClickGoToExecution
          break
        default:
          callback = null
          break
      }
      if (!row.id) {
        callback = null
      }
      return (
        _.isNull(callback)
          ? ''
          : <Button
              compact={true}
              icon='arrow right'
              color='blue'
              onClick={callback(row.id)}
            />
      )
    },
    width: '40px',
    align: 'right'
  }),
  itemHistoryEvent: {
    id: 'event',
    title: 'Evénement',
    render: (row) => (
      <span>
        {row.name}
        {' '}
        {
          row.status && row.message
            ? <Details
                icon={row.status.toLowerCase()}
                action={Details.ACTION.HOVER}
                content={row.message}
              />
            : null
        }
      </span>
    )
  },
  itemInventory: {
    id: 'inventory',
    title: 'Inventaire',
    render: (row) => {
      let { icon, content } = AppUtils.getDetailsInventory(row)
      return (
        <Details
          icon={icon}
          action={Details.ACTION.HOVER}
          content={content}
        />
      )
    },
    width: '90px',
    align: 'center'
  },
  itemMaintenance: {
    id: 'maintenance',
    title: 'Maintenance',
    render: (row) => {
      const maintenances = _.map(
        row.maintenances,
        (maintenance) => {
          return _.extend(
            {},
            maintenance,
            {
              remaining: AppUtils.dateToReminder(maintenance.next)
            }
          )
        }
      )
      const worstIcon = AppUtils.worstIcon(_.map(
        maintenances,
        (maintenance) => (maintenance.remaining.icon)
      ))
      return (
        <Details
          icon={worstIcon}
          action={Details.ACTION.CLICK}
          content={
            <div style={{
              width: '350px',
              maxHeight: '160px',
              display: 'flex',
              flexDirection: 'column'
            }}>
              <Table
                columns={[
                  ColumnsProvider.maintenanceName,
                  ColumnsProvider.maintenanceNextWithDetails(false)
                ]}
                data={maintenances}
                error={null}
                isLoading={false}
                emptyMessage="Aucune maintenance à afficher."
                float={true}
              />
            </div>
          }
        />
      )
    },
    width: '110px',
    align: 'center'
  },
  itemNumber: {
    id: 'number',
    title: 'N°',
    render: (row) => (
      <span style={ row.deleted ? { color: 'red'} : {} }>
        {row.number}
      </span>
    ),
    width: '40px'
  },
  itemNumberFull: {
    id: 'number',
    title: 'N°',
    width: '90px'
  },
  itemProduct: {
    id: 'product',
    title: 'Matériel',
    render: (row) => (row.product.name)
  },
  itemQuantity: {
    id: 'quantity',
    title: 'Quantité',
    render: (row) => (row.quantity),
    width: '80px'
  },
  itemQuantityWithDeleted: (context) => ({
    id: 'quantity',
    title: 'Quantité',
    render: (row) => (
      <React.Fragment>
        <span>
          {row.quantity_active}
        </span>
        {
          context.state.itemsShowDeleted && row.quantity_deleted > 0
            ? <span style={{ color: 'red' }}>
                {` (${row.quantity_deleted})`}
              </span>
            : null
        }
      </React.Fragment>
    ),
    width: '80px'
  }),
  itemQuantityWithDetails: (context, columns) => ({
    id: 'quantity',
    title: 'Quantité',
    render: (row) => (
      <React.Fragment>
        <span>
          {context ? row.quantity_active : row.quantity}
        </span>
        {
          context
            ? (
                context.state.itemsShowDeleted && row.quantity_deleted > 0
                  ? <span style={{ color: 'red' }}>
                      {` (${row.quantity_deleted})`}
                    </span>
                  : null
              )
            : null
        }
        {' '}
        <Details
          icon={row.icon}
          action={Details.ACTION.CLICK}
          content={
            <div style={{
              width: context
                ? (context.state.itemsShowDeleted ? 120 : 0) + (!_.isNull(context.props.getData.prefix) ? 40 : 0) + (600) + 'px'
                : (!_.isNull(row.product.prefix) ? 40 : 0) + (600) + 'px',
              maxHeight: '320px',
              display: 'flex',
              flexDirection: 'column'
            }}>
              <Table
                columns={
                  _.isFunction(columns)
                    ? columns(row)
                    : columns
                }
                data={
                  context
                    ? _.filter(
                        row.items,
                        (item) => (
                          context.state.itemsShowDeleted
                          ||
                          _.isNull(item.deleted)
                        )
                      )
                    : row.items
                }
                error={null}
                isLoading={false}
                emptyMessage="Aucune pièce à afficher."
                float={true}
              />
            </div>
          }
        />
      </React.Fragment>
    ),
    width: '100px',
    align: 'center'
  }),
  itemRemark: {
    id: 'remark',
    title: 'Remarque',
    render: (row) => (
      <span style={ row.deleted ? { color: 'red'} : {} }>
        {row.remark}
      </span>
    )
  },
  locationActions: (context) => ({
    id: 'actions',
    title: '',
    render: (row) => (
      <React.Fragment>
        <Grant role={Grant.ROLE.MANAGE}>
          <Button
            compact={true}
            icon='caret up'
            className='not-for-first'
            loading={
              context.props.reorderIsFetching
              &&
              context.props.reorderId === row.id
              &&
              context.props.reorderData
              &&
              context.props.reorderData.direction === AppConstants.REORDER.UP
            }
            onClick={context.onClickReorder(row.id, AppConstants.REORDER.UP)}
          />
        </Grant>
        <Grant role={Grant.ROLE.MANAGE}>
          <Button
            compact={true}
            icon='caret down'
            className='not-for-last'
            loading={
              context.props.reorderIsFetching
              &&
              context.props.reorderId === row.id
              &&
              context.props.reorderData
              &&
              context.props.reorderData.direction === AppConstants.REORDER.DOWN
            }
            onClick={context.onClickReorder(row.id, AppConstants.REORDER.DOWN)}
          />
        </Grant>
        <Grant role={Grant.ROLE.MANAGE}>
          <Button
            compact={true}
            icon='pencil'
            color='orange'
            onClick={context.onClickUpdate(row.id)}
          />
        </Grant>
        <Grant role={Grant.ROLE.ADMIN}>
          <Button
            compact={true}
            icon='trash'
            color='red'
            onClick={context.onClickDelete(row.id)}
          />
        </Grant>
      </React.Fragment>
    ),
    width: '125px',
    align: 'right'
  }),
  locationIsLabeled: {
    id: 'islabeled',
    title: 'Etiquetté',
    render: (row) => (
      row.islabeled
        ? <Icon
            name='checkmark'
          />
        : ''
    ),
    align: 'center',
    width: '100px'
  },
  locationNameHierarchy: {
    id: 'name',
    title: 'Nom',
    hierarchy: {
      colspan: 10,
      eachWidth: 40
    }
  },
  locationPipeInspect: {
    id: 'pipeinspect',
    title: 'Insp. Tuy.',
    render: (row) => (
      row.pipeinspect
        ? <Icon
            name='checkmark'
          />
        : ''
    ),
    align: 'center',
    width: '100px'
  },
  locationPrintedInventory: {
    id: 'printedinventory',
    title: 'Imprimé',
    render: (row) => (
      AppUtils.displayDate(row.printedinventory)
    ),
    width: '120px'
  },
  locationRemark: {
    id: 'remark',
    title: 'Remarque'
  },
  locationStickers: {
    id: 'location',
    title: 'Emplacement',
    render: (row) => (
      <LocationStickers
        stickers={row.location.stickers}
      />
    )
  },
  locationStickersWithLabelStatus: (context) => ({
    id: 'location',
    title: 'Emplacement',
    render: (row) => {
      const hasPrefix = (
        (
          row
          &&
          row.product
          &&
          row.product.prefix
        )
        ||
        (
          context
          &&
          context.props
          &&
          context.props.getData
          &&
          context.props.getData.prefix
        )
      )
      const isItemIncorrectlyLabeled = (item) => (
        !item.islabeled
        ||
        (
          hasPrefix
          &&
          !item.isuniquelabeled
        )
      )
      const incorrectlyLabeledCount = _.isArray(row.items)
        ? _.size(_.filter(
            row.items,
            (item) => (
              isItemIncorrectlyLabeled(item)
              &&
              _.isNull(item.deleted)
            )
          ))
        : null
      const incorrectlyLabeled = _.isArray(row.items)
        ? incorrectlyLabeledCount > 0
        : isItemIncorrectlyLabeled(row)
      return (
        <React.Fragment>
          <LocationStickers
            stickers={row.location.stickers}
          />
          {
            incorrectlyLabeled
              ? <Details
                  icon={Details.ICON.WARNING}
                  action={Details.ACTION.HOVER}
                  content={
                    !_.isNull(incorrectlyLabeledCount)
                      ? `${incorrectlyLabeledCount} pièce${incorrectlyLabeledCount > 1 ? 's ne sont pas étiquettées' : " n'est pas étiquettée"} correctement`
                      : 'Etiquettage incomplet'
                  }
                />
              : null
          }
        </React.Fragment>
      )
    },
    stickers: true
  }),
  maintenanceActions: (callbackUpdate, callbackDelete, callbackSelect) => ({
    id: 'actions',
    title: '',
    render: (row) => (
      <React.Fragment>
        <Grant role={Grant.ROLE.MANAGE}>
          <Button
            compact={true}
            icon='pencil'
            color='orange'
            onClick={callbackUpdate(row.id)}
          />
        </Grant>
        <Grant role={Grant.ROLE.ADMIN}>
          <Button
            compact={true}
            icon='trash'
            color='red'
            onClick={callbackDelete(row.id)}
          />
        </Grant>
        <Button
          compact={true}
          icon='arrow right'
          color='blue'
          onClick={callbackSelect(row.id)}
        />
      </React.Fragment>
    ),
    width: '100px',
    align: 'right'
  }),
  maintenanceLast: {
    id: 'last',
    title: 'Dernière',
    render: (row) => (AppUtils.displayDate(row.last, 'Jamais')),
    width: '100px'
  },
  maintenanceName: {
    id: 'name',
    title: 'Maintenance',
    render: (row) => (row.maintenance.name)
  },
  maintenanceNameBasic: {
    id: 'name',
    title: 'Nom',
    render: (row) => (row.name)
  },
  maintenanceNextWithDetails: (computeReminder) => ({
    id: 'next',
    title: 'Prochaine',
    render: (row) => {
      const remaining = computeReminder
        ? AppUtils.dateToReminder(row.next)
        : row.remaining
      return (
        <React.Fragment>
          {remaining.text}
          {' '}
          {
            remaining.icon
              ? <Details
                  icon={remaining.icon}
                  action={Details.ACTION.HOVER}
                  content={remaining.details}
                />
              : null
          }
        </React.Fragment>
      )
    },
    width: '130px'
  }),
  maintenanceOutside: {
    id: 'outside',
    title: 'Effectuée par',
    render: (row) => (row.outside ? 'Externe' : 'SIS'),
    width: '140px'
  },
  maintenanceProduct: {
    id: 'product',
    title: 'Matériel',
    render: (row) => (row.product.name)
  },
  maintenancePeriodicity: {
    id: 'periodicity',
    title: 'Récurrence',
    render: (row) => (AppUtils.displayPeriodicity(row.periodicity)),
    width: '150px'
  },
  ownerManager: {
    id: 'manager',
    title: 'Responsable',
    render: (row) => (row.manager.name)
  },
  productActions: (context) => ({
    id: 'actions',
    title: '',
    render: (row) => (
      <React.Fragment>
        <Grant role={Grant.ROLE.MANAGE}>
          <Button
            compact={true}
            icon='caret up'
            className='not-for-first'
            loading={
              context.props.productReorderIsFetching
              &&
              context.props.productReorderId === row.id
              &&
              context.props.productReorderData
              &&
              context.props.productReorderData.direction === AppConstants.REORDER.UP
            }
            onClick={context.onClickReorderProduct(row.id, AppConstants.REORDER.UP)}
          />
        </Grant>
        <Grant role={Grant.ROLE.MANAGE}>
          <Button
            compact={true}
            icon='caret down'
            className='not-for-last'
            loading={
              context.props.productReorderIsFetching
              &&
              context.props.productReorderId === row.id
              &&
              context.props.productReorderData
              &&
              context.props.productReorderData.direction === AppConstants.REORDER.DOWN
            }
            onClick={context.onClickReorderProduct(row.id, AppConstants.REORDER.DOWN)}
          />
        </Grant>
        <Grant role={Grant.ROLE.MANAGE}>
          <Button
            compact={true}
            icon='pencil'
            color='orange'
            onClick={context.onClickUpdateProduct(row.id)}
          />
        </Grant>
        <Grant role={Grant.ROLE.ADMIN}>
          <Button
            compact={true}
            icon='trash'
            color='red'
            onClick={context.onClickDeleteProduct(row.id)}
          />
        </Grant>
      </React.Fragment>
    ),
    width: '125px',
    align: 'right'
  }),
  userNameAndFirstName: {
    id: 'name',
    title: 'Nom et prénom'
  },
  userPermission: (title, permission, width) => ({
    id: `auth_${permission}`,
    title,
    render: (row) => (
      row.authorizations[permission]
        ? <Icon name='checkmark' />
        : ''
    ),
    align: 'center',
    width: `${width}px`
  }),
  userRespHardwareGroup: {
    id: 'owners',
    title: 'Groupes matériels',
    render: (row) => (
      row.owners.length === 0
        ? '-'
        : (
            row.owners.length === 1
              ? row.owners[0].name
              : <React.Fragment>
                  {row.owners.length}{' '}
                  <Details
                    icon={Details.ICON.INFO}
                    action={Details.ACTION.CLICK}
                    content={
                      <div style={{
                        width: '250px',
                        maxHeight: '115px',
                        display: 'flex',
                        flexDirection: 'column'
                      }}>
                        <Table
                          columns={[
                            // Nom du groupe
                            ColumnsProvider.genericName
                          ]}
                          data={row.owners}
                          error={null}
                          isLoading={false}
                          emptyMessage="Cet utilisateur n'est responsable d'aucun groupe matériel."
                          float={true}
                        />
                      </div>
                    }
                  />
                </React.Fragment>
          )
    )
  },
  userRespControlGroup: (selectControl) => ({
    id: 'controlgroups',
    title: 'Groupe de contrôle',
    render: (row) => (
      _.size(row.controlgroups) > 0
        ? <React.Fragment>
            {_.size(row.controlgroups)}
            {' '}
            <Details
              icon={Details.ICON.INFO}
              action={Details.ACTION.CLICK}
              content={
                <div style={{
                  width: '600px',
                  maxHeight: '600px',
                  display: 'flex',
                  flexDirection: 'column'
                }}>
                  <Table
                    columns={[
                      // Contrôle
                      ColumnsProvider.controlNameWithLink(selectControl),
                      // Groupe
                      ColumnsProvider.controlGroupName,
                      // Fonction
                      ColumnsProvider.controlGroupUserFunction
                    ]}
                    data={row.controlgroups}
                    error={null}
                    isLoading={false}
                    emptyMessage="Cet utilisateur n'est affilié à aucun contrôle."
                    float={true}
                  />
                </div>
              }
            />
          </React.Fragment>
        : <React.Fragment>
            {'aucun '}
            <Details
              icon={Details.ICON.INFO}
              action={Details.ACTION.HOVER}
              content="Cet utilisateur n'est affilié à aucun contrôle."
            />
          </React.Fragment>
    )
  }),
  userRespMaintenanceContact: (selectControl, selectProduct) => ({
    id: 'controlcontacts',
    title: 'Entretien',
    render: (row) => (
      _.size(row.controlcontacts) > 0
        ? <React.Fragment>
            {_.size(row.controlcontacts)}
            {' '}
            <Details
              icon={Details.ICON.INFO}
              action={Details.ACTION.CLICK}
              content={
                <div style={{
                  width: '500px',
                  maxHeight: '600px',
                  display: 'flex',
                  flexDirection: 'column'
                }}>
                  <Table
                    columns={[
                      // Contrôle
                      ColumnsProvider.controlNameWithLink(selectControl),
                      // Matériel/Tâche
                      ColumnsProvider.controlProductOrTaskContactDetails(selectProduct)
                    ]}
                    data={row.controlcontacts}
                    error={null}
                    isLoading={false}
                    emptyMessage="Cet utilisateur n'est directement lié à aucune tâche d'entretien."
                    float={true}
                  />
                </div>
              }
            />
          </React.Fragment>
        : <React.Fragment>
            {'aucun '}
            <Details
              icon={Details.ICON.INFO}
              action={Details.ACTION.HOVER}
              content="Cet utilisateur n'est directement lié à aucune tâche d'entretien."
            />
          </React.Fragment>
    )
  }),
  userUsername: {
    id: 'username',
    title: "Nom d'utilisateur"
  }
}

export default ColumnsProvider



// WEBPACK FOOTER //
// ./src/utils/ColumnsProvider.js